import { Injectable } from '@angular/core';
import { LayoutService } from '../Services/layout/layout.service';
import { find, flatMapDeep, isEmpty, findIndex, chain } from 'lodash';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StoreService {
	staticContentModel: StaticContentModel;
	globalAttributes: any;
	policyDataSubject = new Subject();
	policyData$ = this.policyDataSubject.asObservable();

	constructor(private layoutService: LayoutService) {
		this.layoutService.staticLayout.subscribe((data) => {
			this.staticContentModel = data;
		});

		this.layoutService.globalAttributes.subscribe((data) => {
			this.globalAttributes = data;
			this.layoutService.currGlobalAttributes = data;
		});
	}

	getAnswers(renderType: string) {
		return this.layoutService.staticLayout.getValue().data.answers[renderType];
	}

	getDynamicContent(name) {
		if (
			this.layoutService &&
			this.layoutService.staticLayout &&
			this.layoutService.staticLayout.getValue() &&
			this.layoutService.staticLayout.getValue().data &&
			this.layoutService.staticLayout.getValue().data.dynamicContent
		)
			return this.layoutService.staticLayout.getValue().data.dynamicContent[name];
	}

	getGlobalAttributes() {
		return this.globalAttributes;
	}

	setGlobalAttribute(key, val) {
		this.globalAttributes[key] = val;
		this.layoutService.globalAttributes.next(this.globalAttributes);
	}

	getValue(name: string, renderType: string) {
		return this.layoutService.staticLayout.getValue().data.answers[renderType][name];
	}

	getControl(name: string, type: string, renderType: string) {
		const control = find(this.layoutService.staticLayout.getValue().data.controls[renderType], {
			name,
			controlType: type,
		});

		if (control) {
			return control;
		} else {
			const childControls = flatMapDeep(
				this.layoutService.staticLayout.getValue().data.controls[renderType],
				'controls'
			);
			return find(childControls, { name });
		}
	}

	getError(control: control, renderType: string) {
		// if (control && 'SectionClaim.OwnerInfoEdit' === control.name) {
		// 	let errorsArray = [];
		// 	control.controls &&
		// 		control.controls.forEach((subControl) => {
		// 			subControl.controls &&
		// 				subControl.controls.forEach((element) => {
		// 					const error = this.layoutService.staticLayout.getValue().data.errors[renderType][element.name];
		// 					if (error) errorsArray.push(error);
		// 				});
		// 		});

		// 	return errorsArray;
		// }
		if (control && control.name === 'Control.OwnerName') {
			let errorsArray = [];
			control.controls.forEach((subControl) => {
				const error = this.layoutService.staticLayout.getValue().data.errors[renderType][subControl.name];
				if (error) errorsArray.push(error[0]);
			});
			return errorsArray.length > 0 ? [errorsArray[0]] : null;
		}

		if (control && !control.controls) {
			const errorsArray = this.layoutService.staticLayout.getValue().data.errors[renderType][control.name];

			return errorsArray && errorsArray[0];
		}

		return chain(control && control.controls)
			.filter((nestedControl) => nestedControl.visible)
			.sortBy('sequence')
			.map((nestedControl: any) => this.getError(nestedControl, renderType))
			.filter((error) => error)
			.head()
			.value();

		//  return !isEmpty(this.layoutService.staticLayout.getValue().data.errors) ? this.layoutService.staticLayout.getValue().data.errors[renderType][name] : null;
	}

	getAddressError(control, renderType) {
		// The errors for Address children are: [AddressName].[ChildName]
		// return chain(
		//   this.layoutService.staticLayout.getValue().data.errors[renderType]
		// )
		//   .find((error, name) => startsWith(name, control.name + '.'))
		//   .head()
		//   .value();
	}

	getPreloaderAjaxInfo() {
		return this.layoutService.staticLayout.getValue().data.metadata.page.ajaxInfo;
	}

	getAuditing(control: control, renderType: string) {
		if (!control) {
			return;
		}

		if (!control.controls) {
			const auditItem = this.layoutService.staticLayout.getValue().data.auditInfo[renderType][control.name];
			// add space after comma
			if (auditItem && auditItem.filledData) {
				auditItem.filledData = auditItem.filledData.replace(/,/g, ', ');
			}

			return auditItem;
		}
		const auditInfo = {
			type: '',
			filledData: [],
			indicator: '',
		};

		chain(control.controls)
			.filter((nestedControl) => nestedControl.visible)
			.sortBy('sequence')
			.map((nestedControl: any) => this.getAuditing(nestedControl, renderType))
			.filter((audit: any) => audit)
			.map((audit: any) => {
				auditInfo.type = audit.type;
				auditInfo.indicator = audit.indicator;
				// init array if first element in array exists
				const tempAudit = {
					text: audit.filledData,
					color: audit.type,
					name: audit.name,
					indicator: audit.indicator,
					lastComplexChangedDate: audit.lastComplexChangedDate,
				};
				// push exiting element to array
				auditInfo.filledData.push(tempAudit);
			})
			.value();

		return isEmpty(auditInfo.filledData) ? undefined : auditInfo;

		//  return this.layoutService.staticLayout.getValue().data.errors[renderType][name];
	}

	getAddOnParams() {
		return this.layoutService.addonParams.getValue();
	}

	updateData(name: string, value: any, renderType: string) {
		this.layoutService.staticLayout.getValue().data.answers[renderType][name] = value;
	}

	updateControlAttributes(name: string, renderType: string, attr: any, parentName?: string) {
		this.staticContentModel = this.layoutService.staticLayout.getValue();
		let control;
		if (!parentName) {
			control = find(this.staticContentModel.data.controls[renderType], {
				name,
			});
			if (isEmpty(control)) {
				console.error('control not found');
				return;
			}
			control = { ...control, ...attr };
			this.layoutService.staticLayout.getValue().data.controls[renderType][name] = control;
		} else {
			// update control with parent
			let parentControl = find(this.staticContentModel.data.controls[renderType], { name: parentName });

			if (!parentControl) {
				parentControl = find(this.staticContentModel.data.controls[renderType], {
					name: 'PolicyData.PropertyAddressDisplay',
				}).controls[0];
			}

			const parentIndex = findIndex(this.staticContentModel.data.controls[renderType], { name: parentName });

			control = !isEmpty(parentControl) ? find(parentControl.controls, { name }) : '';
			if (parentControl) {
				const controlIndex = findIndex(parentControl.controls, { name });
				if (isEmpty(parentControl) || !parentIndex || isEmpty(control) || !controlIndex) {
					console.error('control not found');
					return;
				}
				this.layoutService.staticLayout.getValue().data.controls[renderType][parentIndex].controls[controlIndex] = {
					...control,
					...attr,
				};
			}
		}
	}

	getState() {
		return this.layoutService.staticLayout.getValue();
	}

	setAddressErrors(name: string, value: any, renderType: string) {
		this.staticContentModel = this.layoutService.staticLayout.getValue();
		this.staticContentModel.data.errors[renderType][name] = value;
		//  this.layoutService.staticLayout.next(this.staticContentModel);
	}

	closePopup() {
		this.staticContentModel = this.layoutService.staticLayout.getValue();
		this.staticContentModel.data.ui.popup = {};
		this.layoutService.staticLayout.next(this.staticContentModel);
	}

	closeModal() {
		this.staticContentModel = this.layoutService.staticLayout.getValue();
		this.staticContentModel.data.ui.modal = {};
		this.layoutService.staticLayout.next(this.staticContentModel);
	}

	removeControl(name: string, renderType: string) {
		this.staticContentModel.data.controls = this.layoutService.staticLayout.getValue().data.controls[renderType];
	}
}
